import React from 'react';
import { Outlet } from 'react-router';
import { useMediaQuery } from 'react-responsive';

import { tablet } from '../../constants/breakpoints';

import Box from '../common/box/Box';

import Profile from './profile';
import { AccessKeys } from './accessKeys/AccessKeys';
import { Members } from './members/Members';
import MemberDetails from './members/MemberDetails';
import Account from './account';
import SettingsTabs from './SettingsTabs';

const Settings = () => {
  const isTablet = useMediaQuery({ query: `(max-width: ${tablet}px)` });
  return (
    <Box
      display="flex"
      justifycontent="center"
      direction="column"
      alignitems="center"
      mr={isTablet ? '16px' : '0'}
      ml={isTablet ? '16px' : '0'}
    >
      <Box
        w="800px"
        display="flex"
        direction="column"
        maxwidth="800px"
        p="0 0 30px"
        alignitems="center"
      >
        <SettingsTabs />
        <Outlet />
      </Box>
    </Box>
  );
};

Settings.childrenRoutes = [
  { redirectTo: '/settings/profile', index: true },
  { path: '/settings/profile', Component: Profile },
  { path: '/settings/members/:id', Component: MemberDetails },
  { path: '/settings/members', Component: Members },
  { path: '/settings/access-keys', Component: AccessKeys },
  { path: '/settings/account', Component: Account }
];

export default Settings;
